<ng-container *ngIf="hide === false">
    <app-loading *ngIf="loading && displayLoading" [showText]="false"></app-loading>
    <ng-content></ng-content>
</ng-container>
